const c = "???-", o = "{", r = "}", g = (i = "", e = {}) => {
  const s = Object.keys(e).map(
    (n) => `${o}${n}${r}`
  ), l = new RegExp(s.join("|"), "gi");
  return i.replace(l, (n) => {
    const t = e[n.substring(o.length, n.length - r.length)];
    return !t || typeof t == "string" ? t : t.toString();
  });
};
export {
  g as i,
  c as n
};
